// GENERATED by scripts/stamp-version.js — do not edit, do not commit.
// Rewritten on every npm start / npm run build / npm test.
export const BUILD_VERSION = "0.1.0-20261103.121019.95c1292";
export const BUILT_AT = "2026-11-03T06:40:19.386Z";
